// Reusable primary action button

export function createContinueButton(label: string, options?: { disabled?: boolean }): HTMLButtonElement {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className =
    'btn-primary w-full flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed';
  btn.textContent = label;
  btn.disabled = options?.disabled ?? false;
  return btn;
}

// Convenience helper to swap loading state text
export function setButtonLoading(
  btn: HTMLButtonElement,
  loading: boolean,
  label: string,
  loadingLabel = 'Working...'
): void {
  btn.disabled = loading;
  btn.textContent = loading ? loadingLabel : label;
}
